import { createResourceKeys } from "@/lib/resource-context";

export const pluginsKeys = createResourceKeys("plugins");

export const hooksKeys = createResourceKeys("hooks");
